<h2 mat-dialog-title>Folder Location</h2>
<mat-dialog-content>
    <div style="padding: 16px 2px; text-indent: 8px;">
        <p>To repair the documents with the missing production source files, please provide the desired server and folder location to start the repair process.</p>  
    </div>
    <div [formGroup]="uploadFormGroup" style="display:flex; flex-direction: column;">
        <mat-form-field appearance="outline" style="flex-grow: 1">
            <mat-label>File Server</mat-label>
            <mat-select formControlName="fileServer">
                <mat-option value="austin">Austin</mat-option>
                <mat-option value="amazon">Amazon</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" style="flex-grow: 6">
            <mat-label>Folder Path</mat-label>
            <input matInput
                placeholder="<driveletter>:\<path>\<to>\<files> (IE: D:\Processing_Files\Job_Opportunity_Folder)"
                formControlName="folderPath" />
                @if (uploadFormGroup.get('folderPath').hasError('required')) {
                    <mat-error>
                        <span><strong>Folder Path</strong> is required.</span>
                    </mat-error>
                }
                @if (!uploadFormGroup.get('folderPath').hasError('required') && uploadFormGroup.get('folderPath').hasError('invalidUri')) {
                    <mat-error>
                        <span>The folder path is invalid. Please follow the standard format:<br> (IE:
                            D:\Processing_Files\Job_Opportunity_Folder)</span>
                    </mat-error>
                }
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions
    style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button id="upload-folder-ok-dialog-button" mat-raised-button color="primary" [disabled]="uploadFormGroup.invalid"
        (click)="ok()">Upload</button>
    <button id="upload-folder-cancel-dialog-button" mat-raised-button color="secondary"
        (click)="cancel()">Cancel</button>
</mat-dialog-actions>